/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ROUTE_PREFIX } from '../src/constants';

const childRoutes = [];

export const passSelectionBySite = (siteId) => `${ROUTE_PREFIX}/${siteId}`;
export const passSelectionRouteWithReservation = (siteId, resId) =>
    `${passSelectionBySite(siteId)}/reservation/${resId}`;
export const passSelectionCreateRoute = (siteId) =>
    `${passSelectionBySite(siteId)}/create/reservation`;
export const passSelectionRouteWithPassType = (siteId, passTypeId) =>
    `${passSelectionBySite(siteId)}/${passTypeId}`;

// CREATING a reservation
childRoutes[childRoutes.length] = {
    path: '/sitepass/:siteId/create/reservation',
    componentName: 'PassOrderDetailsPage',
    title: 'Order Details',
};

// UPDATING a reservation
childRoutes[childRoutes.length] = {
    path: '/sitepass/:siteId/reservation/:resId',
    componentName: 'PassOrderDetailsPage',
    title: 'Order Details',
};

// FOCUSING on a pass type
childRoutes[childRoutes.length] = {
    path: '/sitepass/:siteId/:passTypeId',
    componentName: 'PassSelectionPage',
    title: 'Pass Selection',
};

// SELECTING PASS TYPES for a site / UPDATING an order
childRoutes[childRoutes.length] = {
    path: '/sitepass/:siteId',
    componentName: 'PassSelectionPage',
    title: 'Pass Selection',
};

export default childRoutes;

// cSpell:ignore sitepass
